import pegasus from "./01-pegasus.js";

// Check if text is overflowing
function isTextOverflowing(element) {
    return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
}

//Init cloudflare email decoder (Cloudflare obfuscates emails for protection)
document.addEventListener("DOMContentLoaded", function () {
    pegasus.decodeAllCloudflareEmails();

    // Check if heading is overflowing and add .responsive-heading
    document.querySelectorAll('.js-is-text-overflowing').forEach((element) => {
        if (isTextOverflowing(element)) {
            element.classList.remove('has-x-large-font-size');
            element.classList.add('responsive-heading');
        }
    });
});
